module.exports = __webpack_public_path__ + "static/img/logo.f4260838.svg";